// extracted by mini-css-extract-plugin
export default {"iconColor":"#071948","disabledIconColor":"#b5bac8","link":"style--link--e132a3","enabled":"style--enabled--a3c686","disabled":"style--disabled--a368be"};